import type { ListBuilderList } from '../../../types';
import { createDefaultCompetitorColumns } from '../columns';
import { INACTIVE_COMPETITORS_RULE } from '../shared';

/** Competitors marked inactive: kept on old links and prices, out of the main list. */
export const inactiveCompetitorsList: ListBuilderList = {
	id: 'default-competitors-inactive',
	cacheTTL: 600000,
	name: 'Inactive',
	type: 'default',
	active: true,
	sortOrder: 4,
	columns: createDefaultCompetitorColumns(),
	description: 'Competitors marked inactive',
	defaultSortId: 'column-competitor-name-asc',
	filterRules: {
		competitorStatus: INACTIVE_COMPETITORS_RULE,
	},
};
